module.exports = __webpack_public_path__ + "img/GPDLOGO.9db46dd8.png";